import i18next from 'i18next'
import moment from 'moment'
import store from '../redux/store'
import { getLatitude, getLongitude } from './tools'

export const factory = {
    createCustomerRegistration,
    createEditCustomer,
    createCustomer,
    createLogin,
    createTripRequest,
    createModifyTripRequest,
    formatDate,
    parseJwt,
    createGetTripServices,
    createUpdateRequestForm,
    createItemMultipleTripResult,
}

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
}

function parseJwt(token) {
    let base64Url = token.split('.')[1]
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    let jsonPayload = decodeURIComponent(
        atob(base64)
            .split('')
            .map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
            })
            .join(''),
    )

    return JSON.parse(jsonPayload)
}

function createCustomer(
    name,
    surname1,
    surname2,
    identityDocumentCode,
    email,
    phone,
    isPMR,
    hasWheelChair,
    birthDate,
    secondaryPhone,
) {
    return {
        name: name,
        fullSurname: surname1 + ' ' + surname2,
        surname1: surname1,
        surname2: surname2,
        identityDocumentCode: identityDocumentCode,
        email: email,
        phone: phone,
        isPMR: isPMR,
        hasWheelChair: hasWheelChair,
        birthDate: birthDate,
        secondaryPhone: secondaryPhone,
    }
}

function createCustomerRegistration(
    email,
    password,
    firstName,
    surname1,
    document,
    gdprAccepted,
    birthDate,
    phone,
) {
    return {
        email: email,
        password: password,
        name: firstName,
        surname1: surname1,
        identityDocumentCode: document,
        gdprAccepted: gdprAccepted,
        birthDate: moment(birthDate),
        phone: phone,
        lang: 'ca',
    }
}

function createEditCustomer(
    email,
    firstName,
    lastName,
    lastName2,
    phone,
    ID,
    isPMR,
    hasWheelChair,
    related,
    birthDate,
    addressPosition,
    favouriteAddresses,
    secondaryPhone,
) {
    return {
        email: email,
        name: firstName,
        surname1: lastName,
        surname2: lastName2,
        birthDate: birthDate,
        phone: phone,
        identityDocumentCode: ID,
        addressPosition: addressPosition,
        isPMR: isPMR,
        hasWheelChair: hasWheelChair,
        relatedCustomers: related,
        favouriteAddresses: favouriteAddresses,
        secondaryPhone: secondaryPhone,
    }
}

function createLogin(loginId, password) {
    return {
        email: loginId,
        password: password,
        returnSecureToken: true,
    }
}

function createTripRequest({
    origin,
    originAddress,
    destination,
    destinationAddress,
    isRequestByDropOff,
    originalTripId,
    outboundTripId,
    isMultipleRequest,
    numPassengers,
    requestPickUpStartTime,
    customerName,
    hasWheelChair,
    observation,
    babyCart,
    luggage,
    serviceId,
    customerDateOfBirth,
    serviceName,
    isOnRelatedCustomerBehalf,
    relatedCustomer,
    serviceLineDirection = null,
    idStopP,
    idStopD,
    isReturn = false,
}) {
    let lang = i18next.language
    if (store.getState().customerReducer.currentUser != null) {
        lang = store.getState().customerReducer.currentUser.language
    }
    const res = {
        pickUpLocation: {
            lat: getLatitude(origin.position),
            lon: getLongitude(origin.position),
            address: originAddress,
            id: idStopP?.replace('myCustomAddress', ''),
        },
        dropOffLocation: {
            lat: getLatitude(destination.position),
            lon: getLongitude(destination.position),
            address: destinationAddress,
            id: idStopD?.replace('myCustomAddress', ''),
        },
        requestPickUpStartTime: requestPickUpStartTime,
        numPassengers: numPassengers,
        customerName: customerName,
        hasWheelChair: hasWheelChair,
        luggage: luggage,
        serviceId: serviceId,
        customerDateOfBirth: customerDateOfBirth,
        serviceName: serviceName,
        customerNotificationLanguage: lang,
        isOnRelatedCustomerBehalf: isOnRelatedCustomerBehalf || false,
        observation: observation,
        relatedCustomer: relatedCustomer || null,
        serviceLineDirection: serviceLineDirection
            ? capitalizeFirstLetter(serviceLineDirection)
            : '',
        isMultipleRequest: isMultipleRequest,
        isRequestByDropOff: isRequestByDropOff,
        isReturn: isReturn,
    }

    if (originalTripId) {
        res.originalTripId = originalTripId
    }

    if (outboundTripId) {
        res.outboundTripId = outboundTripId
    }

    return res
}

function createModifyTripRequest({
    origin,
    destination,
    isRequestByDropOff,
    numPassengers,
    requestPickUpStartTime,
    customerName,
    hasWheelChair,
    /*babyCart,*/ luggage,
    pushToken,
    customerDateOfBirth,
    serviceName,
    isOnRelatedCustomerBehalf,
    relatedCustomer,
    passengerId,
}) {
    let lang = i18next.language
    if (store.getState().customerReducer.currentUser != null) {
        lang = store.getState().customerReducer.currentUser.language
    }
    return {
        pickUpLocation: origin,
        dropOffLocation: destination,
        requestPickUpStartTime: moment(requestPickUpStartTime).utc().format('YYYY-MM-DD HH:mm'),
        numPassengers: numPassengers,
        customerName: customerName,
        hasWheelChair: hasWheelChair,
        luggage: luggage, //integer
        //"customerExpoPushToken": pushToken,
        customerDateOfBirth: customerDateOfBirth,
        serviceName: serviceName,
        customerNotificationLanguage: lang,
        isOnRelatedCustomerBehalf: isOnRelatedCustomerBehalf || false,
        relatedCustomer: relatedCustomer || null,
        passengerId: passengerId,
        isRequestByDropOff: isRequestByDropOff,
    }
}

function formatDate(date, format) {
    let minDate = moment.utc('0001-01-01') // minimum value as per UTC

    let receiveDate = moment(date)
    if (moment.utc(receiveDate).isAfter(minDate)) {
        return receiveDate.format(format)
    } else {
        return ''
    }
}

function createGetTripServices(
    trip,
    pushToken,
    customerDateOfBirth,
    newTime,
    isReturn,
    outboundTripId,
    isMultipleRequest,
    isRequestByDropOff,
) {
    return {
        ...createGetTripServicesBase(
            trip,
            pushToken,
            customerDateOfBirth,
            newTime,
            isReturn,
            outboundTripId,
            isMultipleRequest,
            isRequestByDropOff,
        ),
        pickUpLocation: { ...trip.dropOffLocation },
        dropOffLocation: { ...trip.pickUpLocation },
    }
}

function createGetTripServicesBase(
    trip,
    pushToken,
    customerDateOfBirth,
    newTime,
    isReturn,
    outboundTripId,
    isMultipleRequest,
    isRequestByDropOff,
) {
    const newMoment = moment(newTime, 'HH:mm')
    return {
        customerId: trip.customerId.slice(),
        requestPickUpStartTime: moment(trip.requestPickUpStartTime)
            .set({ hours: newMoment.hours(), minutes: newMoment.minutes() })
            .toDate(),
        numPassengers: trip.numPassengers,
        customerExpoPushToken: pushToken.slice(),
        customerNotificationLanguage: null,
        luggage: trip.luggage,
        hasWheelChair: trip.hasWheelChair,
        customerDateOfBirth: customerDateOfBirth.slice(),
        customerName: trip.customerName?.slice(),
        isOnRelatedCustomerBehalf: trip.isOnRelatedCustomerBehalf,
        relatedCustomer: trip.relatedCustomerId?.slice(),
        isReturn: isReturn,
        outboundTripId: outboundTripId,
        isMultipleRequest: isMultipleRequest,
        originalTripId: trip.originalTripId,
        isRequestByDropOff: isRequestByDropOff,
    }
}

function createUpdateRequestForm(
    trip,
    pushToken,
    customerDateOfBirth,
    newTime,
    isReturn,
    outboundTripId,
    isMultipleRequest,
    isRequestByDropOff,
) {
    return {
        ...createGetTripServicesBase(
            trip,
            pushToken,
            customerDateOfBirth,
            newTime,
            isReturn,
            outboundTripId,
            isMultipleRequest,
            isRequestByDropOff,
        ),
        pickUpLocation: {
            desc: {
                description: trip.pickUpLocation.address,
            },
            location: { lat: trip.pickUpLocation.lat, lon: trip.pickUpLocation.lon },
        },
        dropOffLocation: {
            desc: {
                description: trip.dropOffLocation.address,
            },
            location: { lat: trip.dropOffLocation.lat, lon: trip.dropOffLocation.lon },
        },
    }
}

function createItemMultipleTripResult(trip) {
    return {
        apiErrors: [],
        hasErrors: false,
        pickupHours: [],
        requestPickUpTime: trip.requestPickUpStartTime,
        tripResponse: trip,
    }
}
